import { render, staticRenderFns } from "./devolucao.vue?vue&type=template&id=98e8d0fa&"
import script from "./devolucao.vue?vue&type=script&lang=js&"
export * from "./devolucao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports